export enum DeploymentMode {
  off = "off",
  off_initialising = "off_initialising",
  test = "test",
  test_initialising = "test_initialising",
  production = "production",
  production_initialising = "production_initialising",
}

export const getTransitionMode = (mode: DeploymentMode) => {
  switch (mode) {
    case DeploymentMode.off:
      return DeploymentMode.off_initialising;
    case DeploymentMode.test:
      return DeploymentMode.test_initialising;
    case DeploymentMode.production:
      return DeploymentMode.production_initialising;
    default:
      throw Error("Not an actual mode");
  }
};
